import React from 'react';
import { Loader2, Info, Landmark, Lock } from 'lucide-react';
import { moduleApi } from '../../lib/api';

/**
 * Onglet « Trésorerie » des Paramètres — scaffold uniquement (2026-09-24).
 *
 * Contrairement à la facturation électronique (chaque établissement fournit sa propre clé), une vraie
 * synchronisation bancaire suppose qu'IAmani détienne elle-même un compte développeur chez un agrégateur
 * DSP2 (Bridge ou Powens — aucune offre en libre-service constatée, tarification sur devis). Ce contrat
 * n'est pas signé : le bouton « Connecter ma banque » reste donc désactivé, comme l'était le bouton
 * « Tester la connexion » de la facturation électronique avant que son circuit d'envoi n'existe.
 */
export const TresorerieSettings: React.FC = () => {
    const [loading, setLoading] = React.useState(true);
    const [bankConnected, setBankConnected] = React.useState(false);

    React.useEffect(() => {
        moduleApi.getTresorerieSettings()
            .then((d: any) => setBankConnected(!!d?.bank_connected))
            .catch(() => setBankConnected(false))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-content-muted" size={24} /></div>;
    }

    return (
        <div className="max-w-2xl space-y-5">
            <div className="flex gap-3 p-4 rounded-2xl bg-surface-soft border border-border">
                <Info size={18} className="text-brand-500 shrink-0 mt-0.5" />
                <div className="text-xs text-content-muted leading-relaxed space-y-1">
                    <p>
                        La synchronisation bancaire (relevé de comptes, rapprochement automatique) n'est pas encore
                        disponible : elle nécessite qu'IAmani se connecte à un partenaire agréé pour l'accès aux
                        données bancaires, ce qui n'est pas encore mis en place.
                    </p>
                    <p>
                        En attendant, la gestion de vos achats et justificatifs reste disponible dans le module Achats.
                    </p>
                </div>
            </div>

            <div className="p-4 rounded-2xl bg-surface-soft border border-border space-y-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-surface flex items-center justify-center border border-border shrink-0">
                        <Landmark size={18} className="text-content-muted" />
                    </div>
                    <div className="min-w-0">
                        <p className="text-sm font-bold text-content">{bankConnected ? 'Banque connectée' : 'Aucune banque connectée'}</p>
                        <p className="text-[11px] text-content-muted">Compte bancaire de l'établissement</p>
                    </div>
                </div>

                <button
                    type="button"
                    disabled
                    title="Bientôt disponible."
                    className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-border text-content-muted text-xs font-bold opacity-50 cursor-not-allowed"
                >
                    <Lock size={14} /> Connecter ma banque
                </button>
            </div>
        </div>
    );
};
